"use client"
import * as React from "react"
import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip"
import { cn } from "../../lib/utils"

interface TipProps {
  /** Plain string or text + `<Kbd />` — see `.cursor/rules/exxat-kbd-shortcuts.mdc` */
  label: React.ReactNode
  children: React.ReactNode
  side?: "top" | "bottom" | "left" | "right"
  /** Merged onto `TooltipContent` — e.g. `z-properties-sheet-tooltip` inside floating sheets. */
  contentClassName?: string
  /** Merged onto `TooltipTrigger` when `asChild` — use `inline-flex` for icon-only hosts. */
  triggerClassName?: string
  /** Forces tooltip above floating sheets (`z-[80]`). Prefer with `z-properties-sheet-tooltip`. */
  contentZIndex?: number
}

export function Tip({
  label,
  children,
  side = "top",
  contentClassName,
  triggerClassName,
  contentZIndex,
}: TipProps) {
  const elevated =
    contentZIndex != null || contentClassName?.includes("properties-sheet-tooltip")

  return (
    <Tooltip>
      <TooltipTrigger asChild className={triggerClassName}>
        {children}
      </TooltipTrigger>
      <TooltipContent
        side={side}
        className={cn("flex flex-wrap items-center gap-1.5", contentClassName)}
        style={elevated ? { zIndex: contentZIndex ?? 100 } : undefined}
      >
        {label}
      </TooltipContent>
    </Tooltip>
  )
}
